import React from "react";

import t from "../../../lib/translate";
import FormField from "../../../components/form-components/FormField";

export function useThermoBlock(cameras) {
    const selectionFields = (t) => [
        { name: "manual", label: t("form.registration.thermo.manual") },
        { name: "download", label: t("form.registration.thermo.download") },
        { name: "camera", label: t("form.registration.thermo.camera") },
        { name: "certificate", label: t("form.registration.thermo.certificate") },
        { name: "calibration", label: t("form.registration.thermo.calibration") },
        { name: "misc", label: t("form.registration.thermo.misc") },
    ];
    
    const textFields = (t) => [
        { name: "serial", label: t("form.registration.serial.label"), required: true },
        { name: "tFirstname", label: t("form.registration.firstname.label"), required: true },
        { name: "tLastname", label: t("form.registration.lastname.label"), required: true },
        { name: "tCompany", label: t("form.registration.company.label"), required: true },
        { name: "tCountry", label: t("form.registration.country.label"), required: true },
        { name: "tCity", label: t("form.registration.city.label"), required: true },
        { name: "tEmail", label: t("form.registration.email.label"), required: true },
        { name: "tPhone", label: t("form.registration.phone.label"), required: true },
        { name: "tCustomer", label: t("form.registration.customer.label"), required: false },
    ];

    return <>
        {selectionFields(t).map(field => <FormField
            type="checkbox"
            key={field.name}
            name={field.name}
            label={field.label}
            placeholder={field.label}
        />)}
        <FormField
            type="select"
            name="device"
            label={t("form.registration.device.label")}
            options={[
                t("form.registration.device.value-01"),
                ...(cameras.nodes.map(n => n.name))
            ]}
            required
        />
        {textFields(t).map(field => <FormField
            type="text"
            key={`thermo-${field.name}`}
            name={field.name}
            label={field.label}
            placeholder={field.label}
            required={field.required}
        />)}
        <FormField
            type="textarea"
            name="info"
            label={t("form.registration.info.label")}
            placeholder={t("form.registration.info.label")}
        />
        <FormField
            type="checkbox"
            name="tGdpr"
            label={t("form.registration.gdpr.label")}
            placeholder={t("form.registration.gdpr.label")}
            required
        />
    </>;
}